import { MESFMain } from "@dexteel/mesf-core";

import "material-icons";
import "material-symbols";
import "react-datepicker/dist/react-datepicker.css";
import { render } from "react-dom";
import "./setup/ag-grid";

import { AuthenticationConfig } from "./setup/auth-config";
import { customConfigurations } from "./setup/configurations";
import { CustomNavbar } from "./setup/navbar";
import { CustomRoutes } from "./setup/routes";

// Logbook configuration
const logbookSettings = {
	entry: {
		withAssetFilter: "selector" as const,
		filterAssets: "area" as const,
		allowAttachments: true,
		canEditAsset: true,
		canEditShift: true,
		showShiftCrew: true,
		exportToExcel: true,
		shiftsRange: 7,
	},
	report: {
		withAssetFilter: "selector" as const,
		filterAssets: "area" as const,
		showAttachments: true,
		showAsset: true,
		showShiftCrew: true,
		exportToExcel: true,
	},
};

render(
	<MESFMain
		showAreaSelector={true}
		routes={CustomRoutes}
		navbar={CustomNavbar}
		navbarTitle={"SWV MES"}
		configurations={customConfigurations as any}
		authentication={AuthenticationConfig}
		logbookSettings={logbookSettings}
	/>,
	document.getElementById("root"),
);
